import { StandardRecordDisciplineSelect } from '../record-discipline/components/standard-record-discipline-select';
import { CompetitionTypeSelect } from '~/pages/competition/components/competition-type-select';
import { WeightClassSelect } from '~/pages/weight/components/weight-class-select';
import { DistrictSelect } from '~/pages/district/components/district-select';
import { SexFilterSelect } from '~/pages/sex/components/sex-filter-select';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Grid } from '~/components/Grid/Grid';
import { querySchema } from './query-schema';
import { toIsMaleFilter } from '~/utils/sex';
import { ChangeEvent } from 'react';

export function StandardRecordListFilters() {
  const { register, setValue, values } = useFilterForm(querySchema.parse);
  const { isSuperUser, user } = useAuthentication();

  function handleCompetitionTypeChange(event: ChangeEvent<HTMLSelectElement>) {
    setValue('competition_type', event.target.value);
    setValue('weight_class', undefined);
  }

  function handleSexChange(event: ChangeEvent<HTMLSelectElement>) {
    setValue('sex', event.target.value);

    if (values.weight_class !== undefined) {
      setValue('weight_class', undefined);
    }
  }

  return (
    <div
      style={{
        borderBottom: '2px solid var(--color-fg-secondary)',
        paddingBottom: 'var(--size-4)',
        marginBottom: 'var(--size-4)',
      }}
    >
      <Grid>
        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <DistrictSelect
            {...register('district')}
            disabled={!isSuperUser}
            defaultValue={user?.permissions.districts_admin[0]?.id ?? values.district}
            placeholder="Alla standardrekord"
            addNationalRecordOption={true}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <CompetitionTypeSelect
            {...register('competition_type')}
            defaultValue={values.competition_type}
            onChange={handleCompetitionTypeChange}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 2 }}>
          <SexFilterSelect {...register('sex')} onChange={event => handleSexChange(event)} defaultValue={values.sex} />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 2 }}>
          <WeightClassSelect
            {...register('weight_class')}
            query={{
              competition_types: values.competition_type ? [values.competition_type] : undefined,
              is_male: toIsMaleFilter(values.sex),
            }}
            onChange={event => setValue('weight_class', event.target.value)}
            key={`${values.sex}-${values.weight_class}`}
            defaultValue={values.weight_class}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 2 }}>
          <StandardRecordDisciplineSelect {...register('discipline')} />
        </Grid.Item>
      </Grid>
    </div>
  );
}
